export default {
    title: '身材觉醒 - 学员端',
    api: 'https://mp.51zhaosijiao.com/api',
    wechat: {
        appid: 'wxfa1427c9432c8ea6',
    },
    uri: {
        trainer: 'https://trainer.51zhaosijiao.com',
        coach: 'https://coach.51zhaosijiao.com',
    },
};



// WEBPACK FOOTER //
// ./src/config.js